import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { Form, Headings, Padding } from '../../../../..'
import WiredLabel from './WiredLabel'

const { FormGroup, Label } = Form
const THOUSAND_MILLISECONDS = 1000

function DeviceStatus({
    data: { date: statusDate, apk_version: statusApkVersion, hdmi: statusHdmi, wired },
    isLoading,
}) {
    const { t } = useTranslation()
    const statusDateInMilliSeconds = statusDate * THOUSAND_MILLISECONDS
    let statusHdmiLabel = t('device-status-hdmi-connected-unknown')

    if (typeof statusHdmi === 'boolean') {
        statusHdmiLabel = statusHdmi ? t('device-status-hdmi-connected-on') : t('device-status-hdmi-connected-off')
    }

    function renderStatus() {
        if (!statusDate) {
            return t('device-status-unknown')
        }

        return (
            <>
                <Label label={t('device-status-current-apk-version')}>{statusApkVersion}</Label>
                <Label label={t('device-status-hdmi-connected')}>{statusHdmiLabel}</Label>
                <Label label={t('device-status-date')}>{moment(statusDateInMilliSeconds).toNow()}</Label>
                <Label label={t('connection')}><WiredLabel wired={wired} /></Label>
            </>
        )
    }

    return (
        <FormGroup title={t('device-status')}>
            <Padding top bottom size="xs">
                {isLoading && <Headings.H5>Loading...</Headings.H5>}
                {!isLoading && renderStatus()}
            </Padding>
        </FormGroup>
    )
}

DeviceStatus.propTypes = {
    data: PropTypes.shape({
        device: PropTypes.string,
        store_code: PropTypes.string,
        date: PropTypes.number,
        apk_version: PropTypes.string,
        hdmi: PropTypes.bool,
    }),
    isLoading: PropTypes.bool,
}

DeviceStatus.defaultProps = {
    data: {},
    isLoading: false,
}

export default DeviceStatus
